import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import StepTracker from 'components/StepTracker'
import { getUserAlias } from 'models/ProfileInfo/selectors'
import { COLOURS, STRING } from 'resources'
import { getReklaimProtectDeletionData } from 'services/reklaimProtect'

import { Container, Title } from './styles'

const DeleteStatus = ({ setBrokerDeletes }) => {
  const userAlias = useSelector(getUserAlias)
  const [deletionData, setDeletionData] = useState(null)

  const fetchDeletionData = useCallback(async () => {
    const protectDeletionData = await getReklaimProtectDeletionData(userAlias)
    if (protectDeletionData?.dataBrokersRemoved) {
      setBrokerDeletes(protectDeletionData.dataBrokersRemoved)
    }
    setDeletionData(protectDeletionData)
  }, [userAlias, setBrokerDeletes, setDeletionData])

  useEffect(() => {
    fetchDeletionData()
  }, [fetchDeletionData])

  return (
    <Container>
      <Title>{STRING.protect.deleteStatus.title}</Title>
      <StepTracker
        color={COLOURS.secondaryPurple2}
        height={15}
        completedSteps={deletionData?.dataBrokersRemoved}
        totalSteps={deletionData?.totalDataBrokers}
      />
    </Container>
  )
}

DeleteStatus.propTypes = {
  setBrokerDeletes: PropTypes.func.isRequired,
}

export default DeleteStatus
